import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'

import { accountsService } from 'src/services/accounts.service'
import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'

import { IAccountUpdateFormDto } from 'src/types'
import { QUERY_KEYS } from 'src/constants'

const useEditAccount = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async ({ image, oldIcon, oldMedia, media, locale, ...account }: IAccountUpdateFormDto) => {
      const updatedIcon = await mediaEntityUploadService.updateIcon(oldIcon, image)
      const updatedMedia = await mediaEntityUploadService.updateMedia(oldMedia, media)

      return accountsService.updateAccount(
        {
          ...account,
          image: updatedIcon ? updatedIcon[0] : image.icon,
          image_small: updatedIcon ? updatedIcon[1] : account.image_small,
          image_medium: updatedIcon ? updatedIcon[2] : account.image_medium,
          media: updatedMedia,
          locale,
        },
        accountId ?? '',
      )
    },
    {
      onSuccess: async (data) => {
        if (!data) return
        await queryClient.resetQueries([QUERY_KEYS.ACCOUNT, accountId])
      },
    },
  )
}

export { useEditAccount }
